export type ScreenOrientationValue = 'portrait' | 'landscape'

export const normalizeOrientation = (type: string): ScreenOrientationValue | string => {
    if (type.startsWith('portrait')) {
        return 'portrait'
    }

    if (type.startsWith('landscape')) {
        return 'landscape'
    }

    return type
}
